module.exports = __webpack_public_path__ + "img/Dantam Hair 38.b462fe7a.jpg";